<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :close-on-click-modal="false"
    title="订单确认"
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
    ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <div slot="title" class="dialog-header-title">
      <span class="name">订单确认</span>
    </div>
    <div class="form_content" style="padding: 20px">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-row class="form_head_title">
          
          客户信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单编号:" prop="order_no">
              <el-input v-model="formData.order_no" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单日期:" prop="order_time">
              <el-date-picker v-model="formData.order_time" format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" disabled
              style="width:100%"
              > </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称:" prop="customer_name">
              <el-input v-model="formData.customer_name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建人:" prop="create_user">
              <el-input v-model="formData.create_user" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人:" prop="contacts">
              <el-input v-model="formData.contacts" disabled> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话:" prop="contacts_phone">
              <el-input v-model="formData.contacts_phone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title">
          
          订单信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称:" prop="account_name">
              <el-input v-model="formData.account_name" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目前状态:" prop="account_status">
              <el-select v-model="formData.account_status" placeholder="请选择" disabled
              style="width:100%"
              >
                <el-option v-for="item in cellStatusList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="套餐名称:" prop="contacts_package">
              <el-input v-model="formData.contacts_package" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单金额:" prop="order_amount">
              <form-input :numberVal="formData.order_amount" :disabled="true" @setVal="setVal" :keyName="'order_amount'"></form-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="充值时间(年):" prop="recharge_years">
              <form-input :numberVal="formData.recharge_years" :disabled="true" @setVal="setVal" :keyName="'recharge_years'"></form-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="购买用户数:" prop="users_number">
              <form-input :numberVal="formData.users_number" :disabled="true" @setVal="setVal" :keyName="'users_number'"></form-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="购买次数(次):" prop="purchases_number">
              <form-input :numberVal="formData.purchases_number" :disabled="true" @setVal="setVal" :keyName="'purchases_number'"></form-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注:" prop="remark">
          <el-input v-model="formData.remark" disabled></el-input>
        </el-form-item>
        <el-row class="form_head_title">
          
          订单确认
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="审核人:" prop="reviewer_name">
              <el-input v-model="formData.reviewer_name" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话:" prop="reviewer_phone">
              <el-input v-model="formData.reviewer_phone" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审核时间:" prop="audit_date">
              <el-date-picker v-model="formData.audit_date" format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" disabled> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="审核意见:" prop="remarks">
          <el-input v-model="formData.remarks" type="textarea" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-form-item label="是否通过:" prop="reviewer_results">
              <el-radio-group v-model="formData.reviewer_results">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="0">不通过</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="beforeCloseDialog">取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">保存</el-button>
    </div>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import * as constants from './constants'
import FormInput from './formInput.vue'
export default {
  components: { FormInput },
  data() {
    return {
      drawerSize: '70%',
      formData: {
        order_no: '',
        order_time: '',
        customer_name: '',
        customer_id: '',
        create_user: '',
        contacts: '',
        contacts_phone: '',
        account_key: '',
        account_name: '',
        account_status: '',
        contacts_package: '',
        remark: '',
        recharge_years: 0,
        users_number: 0,
        purchases_number: 0,
        order_amount: 0,
        remarks: '',
        reviewer_name: '',
        reviewer_phone: '',
        audit_date: '',
        reviewer_results: ''
      },
      rules: {
        reviewer_results: [{ required: true, message: '请确认审核结果！', trigger: 'blur' }]
      },
      ...constants,
      loading: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    orderId: {
      type: String,
      default: () => ''
    },
    isEdit: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.loadData()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.formData.audit_date = utils.formatDate(new Date())
      this.formData.reviewer_name = this.$store.state.user.currentUserDetail.user.fullname
      this.formData.reviewer_phone = this.$store.state.user.currentUserDetail.user.mobile
      if (this.orderId) {
        this.$http.get('${third}/costcenter/third_order/' + this.orderId).then((res) => {
          if (res.data) {
            if (res.data.account_status) {
              res.data.account_status = parseFloat(res.data.account_status)
            }
            const a = this.formData
            const b = res.data
            const newObject = {}
            Object.assign(newObject, a, b)
            this.formData = newObject
          }
        })
      }
    },
    setVal() {},
    //取消/关闭弹窗
    beforeCloseDialog() {
      this.$emit('closeConfirm')
    },
    //提交订单确认
    submit() {
      this.loading = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            refId: this.orderId,
            remark: this.formData.remarks,
            reviewer_name: this.formData.reviewer_name,
            reviewer_phone: this.formData.reviewer_phone,
            audit_date: this.formData.audit_date,
            reviewer_results: this.formData.reviewer_results
          }
          if (!this.isEdit) {
            this.$http.post('${third}/costcenter/third_order_confirm/', params).then((res) => {
              this.loading = false
              if (res.data.state) {
                this.$emit('closeConfirm')
                this.$message.info('订单确认成功！')
              }
            })
          } else {
            this.$http.put('${third}/costcenter/third_order_confirm/', params).then((res) => {
              this.loading = false
              if (res.data.state) {
                this.$emit('closeConfirm')
                this.$message.info('订单确认成功！')
              }
            })
          }
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.botton_button {
  display: flex;
  text-align: center;
  justify-content: center;
}
.form_head_title {
  height: 35px;
  color: #377cff;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
</style>
